import type { CampaignEvent, NewsItem, ParticipationOption } from '../types'

export const featuredStory: NewsItem = {
  category: 'Speech',
  date: '18 August 2026',
  title:
    'Full address: “Nigeria does not have a talent problem. It has a delivery problem.”',
  excerpt:
    'Speaking to 4,000 delegates at the National Economic Summit in Abuja, Adebayo S. Bello set out the case for a government measured on published targets rather than announcements — and committed to an independently audited scorecard every hundred days.',
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/23fed40f-ca99-4026-a7ba-476691c2f191.jpg',
}

export const latestNews: NewsItem[] = [
  {
    category: 'Policy',
    date: '15 August 2026',
    title: 'Bello releases costed plan to end estimated electricity billing',
    excerpt:
      'The 24-page document sets a two-year deadline for universal metering and names the funding source for each phase.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/78758787-cb47-4c4a-80e5-daa7f359f8d3.jpg',
  },
  {
    category: 'Campaign Trail',
    date: '12 August 2026',
    title: 'Three days in the North West: Kano, Katsina and Sokoto',
    excerpt:
      'Meetings with textile employers, displaced farming families and the Kano State teachers’ union.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ebf27f4b-fec1-4388-bbbb-126b7ec20001.jpg',
  },
  {
    category: 'Statement',
    date: '09 August 2026',
    title: 'On the Benue attacks: “Condolences are not a security policy”',
    excerpt:
      'The campaign restates its commitment to a dedicated rural security corps within the first sixty days.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/93340211-d03b-4760-9807-29ce94192f52.jpg',
  },
]

export const upcomingEvents: CampaignEvent[] = [
  {
    type: 'Town Hall',
    title: 'Presidential Town Hall on Jobs & Enterprise',
    city: 'Abuja',
    state: 'FCT',
    date: 'Sat, 29 August',
    time: '6:00 PM WAT',
    venue: 'Transcorp Hilton, Central Business District',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/93340211-d03b-4760-9807-29ce94192f52.jpg',
  },
  {
    type: 'Youth Forum',
    title: 'Building From Home: A Conversation With Founders',
    city: 'Lagos',
    state: 'Lagos',
    date: 'Wed, 2 September',
    time: '4:00 PM WAT',
    venue: 'Landmark Event Centre, Victoria Island',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bd5404b8-d7a4-46e6-9892-2f8d1b841d5a.jpg',
  },
  {
    type: 'Rally',
    title: 'North East Unity Rally',
    city: 'Maiduguri',
    state: 'Borno',
    date: 'Sat, 5 September',
    time: '10:00 AM WAT',
    venue: 'Ramat Square',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/23fed40f-ca99-4026-a7ba-476691c2f191.jpg',
  },
]

export const participationOptions: ParticipationOption[] = [
  {
    title: 'Volunteer in your ward',
    description: 'Door-to-door canvassing, voter education and polling unit support.',
    icon: 'users',
  },
  {
    title: 'Join the digital campaign',
    description: 'Amplify verified messaging and counter misinformation online.',
    icon: 'megaphone',
  },
  {
    title: 'Become a coordinator',
    description: 'Lead a ward or LGA team with training and campaign resources.',
    icon: 'flag',
  },
  {
    title: 'Offer professional skills',
    description: 'Legal, medical, research, data, media and creative volunteering.',
    icon: 'briefcase',
  },
]
